const ROWS = [
    {
        label: 'Price',
        render: plan =>
            plan.priceMonthly
                ? `$${Number(plan.priceMonthly).toFixed(2)}/mo.`
                : '-',
    },
    { label: 'Automations', render: plan => formatLimit(plan.maxAutomations) },
    { label: 'Monitors', render: plan => formatLimit(plan.maxMonitors) },
    { label: 'Backtests', render: plan => formatLimit(plan.maxBacktests) },
    { label: 'Indexes', render: plan => formatLimit(plan.maxIndexes) },
    { label: 'Grid levels', render: plan => formatLimit(plan.maxGridLevels) },
    { label: 'Actions', render: plan => formatLimit(plan.maxActions) },
    {
        label: 'Backtest days',
        render: plan => formatLimit(plan.maxBacktestDays),
    },
    {
        label: 'Backtest candles',
        render: plan => formatLimit(plan.maxBacktestCandles),
    },
    {
        label: 'Notifications/hour',
        render: plan => formatLimit(plan.maxNotificationsPerHour),
    },
    {
        label: 'WS connections',
        render: plan => formatLimit(plan.maxWsConnections),
    },
    { label: 'Futures', render: plan => formatFlag(plan.hasFutures) },
    { label: 'Launch', render: plan => formatFlag(plan.hasLaunch) },
    { label: 'Strategies', render: plan => formatFlag(plan.hasStrategies) },
];

function formatLimit(value) {
    return value === -1 ? 'Unlimited' : value;
}

function formatFlag(value) {
    return value ? 'Yes' : '-';
}

/**
 * props:
 * - plans
 * - currentPlanId
 */
function PlansModal(props) {
    return (
        <div
            className="modal fade"
            id="modalPlans"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="modalTitlePlans"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <p className="modal-title" id="modalTitlePlans">
                            Compare plans
                        </p>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center mb-0">
                                <thead>
                                    <tr>
                                        <th></th>
                                        {props.plans.map(plan => (
                                            <th key={plan.id}>
                                                {plan.name}
                                                {plan.id ===
                                                props.currentPlanId ? (
                                                    <div>
                                                        <span className="badge bg-primary">
                                                            Current
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {ROWS.map(row => (
                                        <tr key={row.label}>
                                            <th className="text-start">
                                                {row.label}
                                            </th>
                                            {props.plans.map(plan => (
                                                <td key={plan.id}>
                                                    {row.render(plan)}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PlansModal;
